import fetch$1 from 'isomorphic-unfetch';
import { getIdToken, isIdTokenExpired } from '@arcteryx/js-auth';
import { GraphQLClient, gql } from 'graphql-request';
import { jwtDecode } from 'jwt-decode';
import Cookies from 'universal-cookie';
import { priceFormat } from '@arcteryx/js-price';

class BazaarVoiceProvider {
  constructor(_ref) {
    let {
      BVApiKey,
      BVApiUrl = "https://stg.api.bazaarvoice.com",
      products = []
    } = _ref;
    this.apiKey = BVApiKey;
    this.apiUrl = BVApiUrl;
    this.productList = products;
  }
  get productSkus() {
    const productSkus = this.productList.map(product => product.id).join();
    return productSkus;
  }

  /*
   * Example output URL:
   * @return https://api.bazaarvoice.com/data/statistics.json?apiversion=5.4&passkey=${BVApiKey}&stats=reviews&filter=productid:eq:X000006596,X000007013
   */
  get requestUrl() {
    const url = new URL(this.apiUrl);
    url.pathname = "/data/statistics.json";
    url.searchParams.append("apiversion", "5.4");
    url.searchParams.append("passkey", this.apiKey);
    url.searchParams.append("stats", "reviews");
    url.searchParams.append("filter", `productid:eq:${this.productSkus}`);
    return url.toString();
  }
  fetchBVRatings() {
    return fetch$1(this.requestUrl).then(res => res.json()).catch(e => console.error(e));
  }
}

function _defineProperty(e, r, t) {
  return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = t, e;
}
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread2(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
function _objectWithoutProperties(e, t) {
  if (null == e) return {};
  var o,
    r,
    i = _objectWithoutPropertiesLoose(e, t);
  if (Object.getOwnPropertySymbols) {
    var s = Object.getOwnPropertySymbols(e);
    for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
  }
  return i;
}
function _objectWithoutPropertiesLoose(r, e) {
  if (null == r) return {};
  var t = {};
  for (var n in r) if ({}.hasOwnProperty.call(r, n)) {
    if (e.includes(n)) continue;
    t[n] = r[n];
  }
  return t;
}
function _toPrimitive(t, r) {
  if ("object" != typeof t || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != typeof i) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == typeof i ? i : i + "";
}

const capitalize = string => {
  return string.charAt(0).toUpperCase() + string.slice(1);
};

const flattenCMSJson = _ref => {
  let {
    item,
    included
  } = _ref;
  // 2) Extracts it's "attributes" values into the return object
  if (typeof item !== "undefined") {
    const returnObject = item.attributes;
    if (item.hasOwnProperty("type")) {
      returnObject.type = item.type;
    }

    // 3) Checks for a "relationships" attribute, if it does, add a memeber to the return object named the same as the relationship key
    if (item.relationships) {
      for (const key in item.relationships) {
        // 4) iterate over the items in the related field's data array (or if not an array, skip straight to processing the object)
        if (item.relationships[key].data instanceof Array === false) {
          // Sometimes the relationships[key] is just an object, sometimes it's an array. Let's always treat them as arrays.
          item.relationships[key].data = [item.relationships[key].data];
        }
        returnObject[key] = item.relationships[key].data.map(related => {
          // 6) call getAttributes on the real entity object, put the results into the new member on the return object (from 3)
          return flattenCMSJson({
            // 5) get the real entity object from the "included" array
            item: included.find(node => (related === null || related === void 0 ? void 0 : related.id) === (node === null || node === void 0 ? void 0 : node.id)),
            included
          });
        });
      }
    }
    return returnObject;
  }
  return null;
};

const generateRandomNumber = function () {
  let length = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 13;
  const array = new Uint8Array(length);
  const cryptoObj = window.crypto || window.msCrypto; // For cross-browser compatibility

  cryptoObj.getRandomValues(array);
  let randomNumber = '';
  for (let i = 0; i < length; i++) {
    randomNumber += array[i] % 10;
  }
  return randomNumber;
};

const FIVE_MINS = 300;
const getJWT = jwt => {
  const idToken = jwt || getIdToken();
  if (isIdTokenExpired(idToken, FIVE_MINS)) {
    return ""; // Need empty string for Magento GraqphQL
  }
  return idToken;
};

const warehouses = {
  us: "OGDEN",
  ca: "VAN",
  jp: "JP",
  other: "UBER"
};

/**
 * New BloomreachProvider()
 * @param {object} configs - object structure = {
 * * {string} apiUrl - core (category) or pathways
 * * {string} country
 * * {string} language
 * * {string} market
 * * {string} gender
 * * {string} filterParam - `attribute 1:("value 1" AND "value 2") AND attribute 2:("value")`
 * * {string} sortParam - "price-ascending"
 * * {srting} uid - personalization uuid
 * * {string} refUrl - previous URL: arcteryx.com
 * * {string} url - current URL: arcteryx.com/c/mens
 * * {string} categoryId - shell-jackets
 * * {object} customSearchParams { widget_id: 1111 } for extra search params like fq filters, widget_id etc.
 * }
 * @return {string} requestUrl
 */
class BloomreachProvider {
  constructor(configs) {
    var _configs$country, _configs$language, _configs$market, _configs$market2, _configs$gender, _configs$apiUrl, _configs$apiUrl2, _configs$apiUrl3;
    this._params = {};
    this.configs = configs;
    this.country = (configs === null || configs === void 0 || (_configs$country = configs.country) === null || _configs$country === void 0 ? void 0 : _configs$country.toLowerCase()) || "ca";
    this.language = (configs === null || configs === void 0 || (_configs$language = configs.language) === null || _configs$language === void 0 ? void 0 : _configs$language.toLowerCase()) || "en";
    this.market = (configs === null || configs === void 0 || (_configs$market = configs.market) === null || _configs$market === void 0 ? void 0 : _configs$market.toLowerCase()) === "sale" ? "outlet" : (configs === null || configs === void 0 || (_configs$market2 = configs.market) === null || _configs$market2 === void 0 ? void 0 : _configs$market2.toLowerCase()) || "outdoor";
    this.gender = (configs === null || configs === void 0 || (_configs$gender = configs.gender) === null || _configs$gender === void 0 ? void 0 : _configs$gender.toLowerCase()) || "mens";
    this.customSearchParams = (configs === null || configs === void 0 ? void 0 : configs.customSearchParams) || [];
    this.filterParam = (configs === null || configs === void 0 ? void 0 : configs.filterParam) || "";
    this.sortParam = (configs === null || configs === void 0 ? void 0 : configs.sortParam) || "";
    this.isCategoryApi = configs === null || configs === void 0 || (_configs$apiUrl = configs.apiUrl) === null || _configs$apiUrl === void 0 ? void 0 : _configs$apiUrl.includes("core");
    this.isPathwaysApi = (configs === null || configs === void 0 || (_configs$apiUrl2 = configs.apiUrl) === null || _configs$apiUrl2 === void 0 ? void 0 : _configs$apiUrl2.includes("pathways")) || (configs === null || configs === void 0 || (_configs$apiUrl3 = configs.apiUrl) === null || _configs$apiUrl3 === void 0 ? void 0 : _configs$apiUrl3.includes("widgets"));
    /**
     * API URL
     * 1. Category and Search API endpoints
     * Doesn't require an auth key
     *
     * 2. Pathways and Recs endpoints
     * Doesn't require an auth key
     */
    this.apiUrl = configs !== null && configs !== void 0 && configs.apiUrl ? `${configs.apiUrl}` : "https://core.dxpapi.com/api/v1/core?";
    const optionalHeaders = (configs === null || configs === void 0 ? void 0 : configs.headers) || {};
    this.headers = _objectSpread2(_objectSpread2({}, optionalHeaders), {}, {
      "Content-Type": "application/json",
      Accept: "application/json"
    });
    this.setAccountId();
    this.setDomainKey();
    this.setAttributes();
    this.setFilters();
    this.setSort();
  }
  setAccountId() {
    const {
      market,
      _params
    } = this;
    const accountIdMap = {
      outdoor: "7358",
      outlet: "7359",
      leaf: "7360"
    };
    _params.account_id = accountIdMap[market];
  }
  setDomainKey() {
    const {
      market,
      language,
      _params
    } = this;
    /**
     * Bloomreach uses ja and nl for Japanese and Norwegian
     * Arc'teryx uses jp and no
     */
    const langCodeMap = {
      jp: "ja",
      no: "nl"
    };
    /**
     * Domain keys for each market and language
     * the default domain key is English
     *
     * outdoor         leaf                 outlet
     * arcteryx        arcteryx_leaf        arcteryx_outlet
     * arcteryx_de     arcteryx_leaf_de     arcteryx_outlet_de
     * arcteryx_fr     arcteryx_leaf_fr     arcteryx_outlet_fr
     * arcteryx_ja     arcteryx_leaf_ja     arcteryx_outlet_ja
     * arcteryx_zh     arcteryx_leaf_zh     arcteryx_outlet_zh
     * arcteryx_es     arcteryx_leaf_es     arcteryx_outlet_es
     * arcteryx_nl     arcteryx_leaf_nl     arcteryx_outlet_nl
     */
    const setMarket = market === "outdoor" ? "" : `_${market}`;
    const setLanguage = language === "en" ? "" : `_${langCodeMap[language] || language}`;
    _params.domain_key = `arcteryx${setMarket}${setLanguage}`;
  }

  /**
   * We need to set the attributes we want to get back from the API in the fl param
   */
  setAttributes() {
    const {
      country,
      _params,
      isCategoryApi,
      isPathwaysApi
    } = this;
    // Attributes we want to get from the API
    // we use the toString method to turn the array into a comma separated string
    const attributes = ["analytics_name", "collection", "colour_images_map",
    // array of images and colours mapped
    `colour_images_map_${country}`,
    // array of images and colours mapped
    "description", `discount_price_${country}`, "gender", "hover_image", "is_new", "is_pro", "is_revised", `price_${country}`, "pid",
    // product id
    "review_count", "rating", "slug", "title", "thumb_image"].toString();
    if (isCategoryApi) {
      _params.fl = attributes;
    }
    if (isPathwaysApi) {
      _params.fields = attributes;
    }
  }
  setFilters() {
    const {
      filterParam,
      _params,
      isCategoryApi
    } = this;
    if (filterParam && isCategoryApi) {
      _params.efq = filterParam;
    }
  }
  setSort() {
    const {
      _params,
      sortParam,
      country,
      market
    } = this;
    const isDescending = sortParam.includes("descending");
    const isAscending = sortParam.includes("ascending");
    const isPrice = sortParam.includes("price");
    const sortName = sortParam.split("-")[0];
    if (isPrice) {
      const sortPrice = market === "outlet" ? `discount_${sortName}` : sortName;
      _params.sort = `${sortPrice}_${country.toLowerCase()}`;
    } else {
      _params.sort = `${sortName}`;
    }
    if (isDescending) {
      _params.sort = `${_params.sort}+desc`;
    }
    if (isAscending) {
      _params.sort = `${_params.sort}+asc`;
    }
  }
  get requestUrl() {
    const {
      configs,
      _params,
      apiUrl,
      country,
      isCategoryApi,
      customSearchParams
    } = this;
    const {
      uid,
      refUrl,
      url: curUrl,
      categoryId,
      productLimit
    } = configs;
    const url = new URL(apiUrl);

    /**
     * Params for the Bloomreach request URL
     * Required params = (*)
     */
    Object.keys(_params).forEach(key => {
      /**
       * Params in this object:
       * account_id (*)
       * domain_key (*) determines language
       * fl * fields/attributes we want
       * fq - filtering for gender
       * efq - complex filtering
       */
      if (key !== "sort") {
        url.searchParams.append(key, _params[key]);
      }
    });
    url.searchParams.append("_br_uid_2", uid); // (*) user id - use cookie generated by pixel
    url.searchParams.append("ref_url", refUrl); // (*)
    url.searchParams.append("url", curUrl); // (*)
    url.searchParams.append("request_id", generateRandomNumber(13)); // (*) An ID to track site visitor clicks (random 13 digit number)
    url.searchParams.append("rows", productLimit || 200); // (*) The number of matching items to return per results page in the API response max at 200 or can set productLimit

    url.searchParams.append("start", 0); // (*) The number of the first item on a page of results.
    /** View param - used for country availability */
    url.searchParams.append("view_id", country); // we will use view_id for the country selection

    // Specific params for the Category API
    if (isCategoryApi) {
      url.searchParams.append("request_type", "search"); // (*) search is the only option for both search and category requests
      url.searchParams.append("search_type", "category"); // (*) The type of search. Value should be keyword for Product Search requests, category for Category requests.
      url.searchParams.append("q", categoryId); // (*) search term, for categories it's the category ID
    }

    // Extra Params usually used for Pathways API
    if (customSearchParams !== null && customSearchParams !== void 0 && customSearchParams.length) {
      /**
       * Potential customSearchParams:
          * PLP Category API params:
            * fq - for adding facet ranges e.g: &fq=rating:[* TO 1] can have multiple fq params
          * Widget Pathway params:
            * widget_id - for custom pages etc.
            * filter - for widget filtering, can send more than 1
              e.g: &filter=(price:["*" TO "100"])&filter=(color_groups: ("blue"))
            * facet - boolean for turning on facets (default is false)
            * cat_id - Unique ID of the Category present in the feed and pixel.
            * item_ids - Product SKU
            * keyword - for search but may use it for dynamic PLPs
       */
      for (const obj of customSearchParams) {
        const key = Object.keys(obj)[0];
        const value = obj[key];
        url.searchParams.append(key, value);
      }
    }
    return _params.sort ? `${url.toString()}&sort=${_params.sort}` : url.toString();
  }
  async fetchProducts() {
    const options = {
      headers: this.headers
    };
    return fetch$1(this.requestUrl, options).then(res => res.json()).catch(e => console.error(e));
  }
}

const getGroupIdFromJwt = token => {
  const decoded = token ? jwtDecode(token) : null;
  return (decoded === null || decoded === void 0 ? void 0 : decoded.groupId) || "CO-1";
};
class MagentoGraphqlProviderError extends Error {
  constructor(message, response) {
    super(message);
    this.response = response;
  }
  hasError(message) {
    return this.response.errors.some(error => error.message.match(message));
  }
}
class MagentoGraphqlProvider {
  constructor(_ref) {
    let {
      url,
      market,
      country,
      language = "en",
      isCheckout = false,
      kioskId,
      enableCaching = false,
      enableLogging = false,
      headers: defaultHeaders = {},
      /** Function to run after sending a request with X-IS-CHECKOUT=true */
      onIsCheckoutRequestSuccess = undefined,
      /** Function to run after sending a request with X-IS-CHECKOUT=false */
      onNotIsCheckoutRequestSuccess = undefined,
      /** Function to send messages to log (e.g. New Relic)  */
      onError = undefined,
      // Pass a callback function to get an access token from the calling 
      // application at the time of request. 
      getAccessToken = async () => ""
    } = _ref;
    const fixedLanguage = language === "jp" ? "ja" : language;
    const storeMap = {
      outdoor: "arcteryx",
      sale: "outlet",
      outlet: "outlet",
      urban: "veilance",
      leaf: "leaf"
    };
    const website = storeMap[market] || "arcteryx";
    const store = `${website}_${fixedLanguage}`;

    /**
     * https://arcteryx.atlassian.net/wiki/spaces/FDP/pages/703595726/GraphQL#3.-Headers
     */
    const headers = _objectSpread2(_objectSpread2({}, defaultHeaders), {}, {
      "X-COUNTRY-CODE": country,
      "X-IS-CHECKOUT": `${isCheckout}`,
      Store: store,
      "Content-Type": "application/json"
    });
    if (kioskId) {
      Object.assign(headers, {
        "KIOSK-STORE-ID": kioskId
      });
    }
    this.url = url;
    this.market = market;
    this.country = country;
    this.language = language;
    this.enableLogging = enableLogging;
    this.headers = headers;
    this.context = enableCaching ? {
      country,
      store
    } : null;
    this.client = new GraphQLClient(url, {
      headers,
      method: enableCaching ? "GET" : "POST"
    });
    this.isCheckout = isCheckout;
    this.onIsCheckoutRequestSuccess = onIsCheckoutRequestSuccess;
    this.onNotIsCheckoutRequestSuccess = onNotIsCheckoutRequestSuccess;
    this.onError = onError;
    this.getAccessToken = getAccessToken;
  }
  async request(query) {
    let variables = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    let headers = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    try {
      const {
        context
      } = this;
      const tstart = new Date().getTime();
      const jwt = (await this.getAccessToken()) || "";

      // if we have a context we need to add a customerGroup to it
      if (context) {
        context.customerGroup = getGroupIdFromJwt(jwt);
      }
      const customHeaders = _objectSpread2(_objectSpread2({
        "X-JWT": jwt
      }, this.headers), headers);
      const data = await this.client.request(query.replace(/\s+/g, " ").trim(), _objectSpread2(_objectSpread2({}, variables), context), customHeaders);
      if (this.enableLogging) {
        const diff = new Date().getTime() - tstart;
        console.log({
          query,
          variables,
          context,
          diff
        });
      }
      if (this.isCheckout && this.onIsCheckoutRequestSuccess) {
        this.onIsCheckoutRequestSuccess();
      } else if (!this.isCheckout && this.onNotIsCheckoutRequestSuccess) {
        this.onNotIsCheckoutRequestSuccess();
      }
      return data;
    } catch (error) {
      var _error$response;
      // eslint-disable-next-line no-magic-numbers
      const errorMessage = `Error in MagentoGraphqlProvider: ${error}`;
      if (((_error$response = error.response) === null || _error$response === void 0 ? void 0 : _error$response.status) === 200) {
        throw new MagentoGraphqlProviderError(errorMessage, error.response);
      } else {
        if (this.onError) {
          var _error$response2;
          const logMessage = `${errorMessage} :_:url: ${this.url} :_:resp.status: ${(_error$response2 = error.response) === null || _error$response2 === void 0 ? void 0 : _error$response2.status}\n:_:query: ${query}`;
          this.onError(logMessage);
        }
        throw new Error(errorMessage);
      }
    }
  }
}

const gqlGetStores = _ref => {
  let {
    storeCode
  } = _ref;
  return gql`
  query getStores(
    ${storeCode ? `$storeCode: String!` : `$term: String!, $radius: Int!`}
  ) {
    pickupLocations(
      sort: { distance: ASC }
      ${storeCode ? `filters: { pickup_location_code: { eq: $storeCode } }` : `area: { radius: $radius, search_term: $term }`}
    ) {
      items {
        pickup_location_code
        name
        description
        latitude
        longitude
        country_id
        region
        region_code
        city
        street
        postcode
        phone
      }
    }
  }
`;
};

// The Magento GraphQL can only support the following:
//  - single sku multiple sources
//  - multiple skus single source
const gqlGetProductInventoryByStores = gql`query getSkuInventory($skus: [String!]!, $storeSources: [String!]!) {
  arcProductsSources(
    skus: $skus
    sources: $storeSources
  ) {
    items {
      sku
      sources {
        source
        qty
      }
    }
  }
}`;

class StoreListProvider {
  constructor(market, country) {
    this.market = market;
    this.country = country;
  }
  getSavedStoreList() {
    var _JSON$parse;
    return ((_JSON$parse = JSON.parse(localStorage.getItem(`nearbyStores-${this.market}`))) === null || _JSON$parse === void 0 ? void 0 : _JSON$parse.stores) || null;
  }
  saveStoreList(storeList) {
    const storeListLocal = {};
    storeListLocal.stores = storeList;
    storeListLocal.savedAt = new Date();
    localStorage.setItem(`nearbyStores-${this.market}`, JSON.stringify(storeListLocal));
  }
  getStoreIds(storeList) {
    return storeList.map(store => store.id);
  }
}

const getStoreQuantity = (storeId, inventoryList) => {
  var _inventoryList$filter;
  return ((_inventoryList$filter = inventoryList.filter(_ref => {
    let {
      source
    } = _ref;
    return source === storeId;
  })[0]) === null || _inventoryList$filter === void 0 ? void 0 : _inventoryList$filter.qty) || 0;
};
const getStoreInventory = (storeId, inventoryList) => {
  const quantities = inventoryList.map(_ref2 => {
    let {
      sources
    } = _ref2;
    return getStoreQuantity(storeId, sources);
  });
  // Return smallest qty from store inventory list
  return quantities.reduce((prevQty, currQty) => Math.min(prevQty, currQty));
};

/**
 *
 * @param {array} dataItems The data.arcProductsSources.items array results from the GraphQL requests
 * @param {array} storeIds  The list of storeIds
 * @returns
 */
const adaptStoreInventoryForMultipleSkus = (dataItems, storeIds) => {
  const storeInventory = [];
  storeIds.forEach(storeId => {
    storeInventory.push({
      source: storeId,
      qty: getStoreInventory(storeId, dataItems)
    });
  });
  return storeInventory;
};
const adaptStoreInventoryForCart = items => {
  // sources[0] because there will only ever be one store for multiple skus
  return items === null || items === void 0 ? void 0 : items.map(item => ({
    sku: item === null || item === void 0 ? void 0 : item.sku,
    qty: item === null || item === void 0 ? void 0 : item.sources[0].qty
  }));
};

const SEARCH_RADIUS_KM = 81; // 81km or 50miles
/**
 *   @param  {string}  apiUrl - The Magento GrapQL endpoint
 *   @param  {string}  market - The market to fetch stores for. Valid markets include outdoor, outlet, leaf, and urban.
 *   @param  {Object}  searchParams - The search parameters or geolocation
 *   @param  {string}  searchParams.searchTerm - Either the region, city, or postcode. Valid search terms include Vancouver, BC, and VH12A3.
 *   @param  {string}  searchParams.country - The two-letter country code.
 *   @param  {number}  searchParams.latitude - The latitude coordinates of the user.
 *   @param  {number}  searchParams.longitude - The longitude coordinates of the user.
 *   @param  {number}  searchParams.distance  - The radius to the search, in kilometers
 */
class MagentoStoreListProvider extends StoreListProvider {
  constructor(_ref) {
    var _searchParams$country;
    let {
      apiUrl,
      market,
      country,
      searchParams
    } = _ref;
    super(market, country);
    this.apiUrl = apiUrl;
    this.market = market;
    this.country = country;
    this.searchParams = searchParams;
    this.provider = new MagentoGraphqlProvider({
      url: apiUrl,
      market,
      country: (searchParams === null || searchParams === void 0 || (_searchParams$country = searchParams.country) === null || _searchParams$country === void 0 ? void 0 : _searchParams$country.toLowerCase()) || country,
      language: "en" // Stores do not have translations
    });
  }

  /**
   *   Fetches store list from Magento based on [searchTerm]{@link https://devdocs.magento.com/guides/v2.4/graphql/queries/pickup-locations.html#PickupLocationFilterInput} and distance radius.
   *   @fetchStores
   */
  async fetchStores() {
    var _this$searchParams, _this$searchParams2, _this$searchParams3;
    let {
      searchKeyword,
      storeCode
    } = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    const radius = ((_this$searchParams = this.searchParams) === null || _this$searchParams === void 0 ? void 0 : _this$searchParams.distance) || SEARCH_RADIUS_KM;
    const searchTerm = searchKeyword || ((_this$searchParams2 = this.searchParams) === null || _this$searchParams2 === void 0 ? void 0 : _this$searchParams2.searchTerm) || "";
    const term = `${searchTerm}:${(_this$searchParams3 = this.searchParams) === null || _this$searchParams3 === void 0 || (_this$searchParams3 = _this$searchParams3.country) === null || _this$searchParams3 === void 0 ? void 0 : _this$searchParams3.toUpperCase()}`;
    try {
      var _nearbyStores$pickupL;
      const nearbyStores = await this.provider.request(gqlGetStores({
        storeCode
      }), {
        radius,
        term,
        storeCode
      });
      return (nearbyStores === null || nearbyStores === void 0 || (_nearbyStores$pickupL = nearbyStores.pickupLocations) === null || _nearbyStores$pickupL === void 0 ? void 0 : _nearbyStores$pickupL.items) || null;
    } catch (error) {
      console.error("Error fetching store data from Magento", error);
    }
    return null;
  }

  /**
   *   Fetches store list from localStorage or fetches from Magento based on [searchTerm]{@link https://devdocs.magento.com/guides/v2.4/graphql/queries/pickup-locations.html#PickupLocationFilterInput} and distance radius.
   *   @getNearbyStores
   *   @param  {boolean}  isNewSearch - If true, it will fetch new stores from Magento or if localStorage is null
   */
  async getNearbyStores() {
    let isNewSearch = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    let storeList = this.getSavedStoreList();
    if (isNewSearch || storeList === null) {
      storeList = await this.fetchStores();
    }
    return storeList;
  }
  async _getStoreInventory(queryVariables) {
    var _results$arcProductsS4, _results$arcProductsS5;
    let multipleSkus = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    let isForCart = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    let bypassAdapter = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
    const results = await this.provider.request(gqlGetProductInventoryByStores, queryVariables);
    if (bypassAdapter) {
      var _results$arcProductsS;
      return results === null || results === void 0 || (_results$arcProductsS = results.arcProductsSources) === null || _results$arcProductsS === void 0 ? void 0 : _results$arcProductsS.items;
    }
    if (multipleSkus && isForCart) {
      var _results$arcProductsS2;
      return adaptStoreInventoryForCart(results === null || results === void 0 || (_results$arcProductsS2 = results.arcProductsSources) === null || _results$arcProductsS2 === void 0 ? void 0 : _results$arcProductsS2.items);
    }
    if (multipleSkus) {
      var _results$arcProductsS3;
      return adaptStoreInventoryForMultipleSkus(results === null || results === void 0 || (_results$arcProductsS3 = results.arcProductsSources) === null || _results$arcProductsS3 === void 0 ? void 0 : _results$arcProductsS3.items, queryVariables.storeSources);
    }
    return results !== null && results !== void 0 && (_results$arcProductsS4 = results.arcProductsSources) !== null && _results$arcProductsS4 !== void 0 && _results$arcProductsS4.items ? results === null || results === void 0 || (_results$arcProductsS5 = results.arcProductsSources) === null || _results$arcProductsS5 === void 0 || (_results$arcProductsS5 = _results$arcProductsS5.items[0]) === null || _results$arcProductsS5 === void 0 ? void 0 : _results$arcProductsS5.sources : 0;
  }

  /**
   *   Fetches store list of inventory for each store for the given product sku
   *   @getStoreInventoryForSingleSku
   *   @param  {string}   sku - the product sku
   *   @param  {array}    storeIds - an array of store IDs
   */
  async getStoreInventoryForSingleSku(sku, storeIds) {
    const inventory = await this._getStoreInventory({
      skus: sku,
      storeSources: storeIds
    });
    return inventory;
  }

  /**
   *   Fetches store list of inventory for each product skus for the given store store ID
   *   @getStoreInventoryForMultipleSkus
   *   @param  {array}   skus - an array of product skus
   *   @param  {string}  storeIds - the store ID
   */
  async getStoreInventoryForMultipleSkus(skus, storeIds) {
    let isForCart = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    const inventory = await this._getStoreInventory({
      skus,
      storeSources: storeIds
    }, true, isForCart);
    return inventory;
  }
  async getStoreInventories(skus, storeIds) {
    const inventory = await this._getStoreInventory({
      skus,
      storeSources: storeIds
    }, true, true, true);
    return inventory;
  }
}

/* eslint-disable */

/**
 * @abstract
 * Abstract class definition for updating P
 */
class PersonalizedPriceProvider {
  /**
   * @interface
   * @param productIds An array of product IDs
   */
  async fetchPrices(productIds) {}

  /**
   * @interface
   * @param productId 
   * @param price The regular base price
   * @param isPro Boolean that indicates if the given productId is a pro product (for legacy)
   */
  personalizePrice(productId, price, isPro) {}
}

const gqlBaseProductQueryPartial = gql`
  sku
  slug
  name
  marketingname
  marketingnameenglish
  productcollectioncode
  is_returnable
  isfootwear
  gendercode
  isnewsizing
`;
const gqlProductPriceRangeQueryPartial = gql`
  price_range {
    minimum_price{
      regular_price{
        value
        currency
      }
      discount {
        amount_off
        percent_off
      }
      final_price {
        value
        currency
        }
      }
    maximum_price{
      regular_price{
        value
        currency
      }
      discount {
        amount_off
        percent_off
      }
      final_price {
        value
        currency
      }
    }
  }
`;
const gqlConfigurableOptionsPartial = gql`
  ... on ConfigurableProduct {
    configurable_options {
      id
      label
      position
      use_default
      attribute_code
      values {
        value_index
        label
        store_label
      }
      product_id
    }
  }
`;
const gqlConfigurableVariantsPartial = gql`
  ...on ConfigurableProduct {
    variants {
      product {
        sku
        upc
        badge_data
        color_data
        size_data
        quantity_available
        productimage
        price_range {
          maximum_price{
            regular_price{
              value
              currency
            }
            discount {
              amount_off
              percent_off
            }
            final_price {
              value
              currency
            }
          }
        }
      }
      attributes {
        code
        label
        value_index
      }
    }
  }
`;
const gqlProductAggregations = gql`
aggregations {
  attribute_code
  label

  options {
    count
    label
    label_en
    value
  }
}
`;
const variantPriceQueryTemplate = (name, filter) => gql`query ${name} {
  products(filter: ${filter}) {
    items {
      name
      sku
      ...on ConfigurableProduct {
        variants {
          product {
            sku
            ${gqlProductPriceRangeQueryPartial}
          }
        }
      }
    }
  }
}`;

// This function generates a GraphQL query for fetching product data.
// It takes a name and a filter as parameters.
const productQueryTemplate = (name, filter) => gql`query ${name} {

  products(filter: ${filter}) {
    items {
      ${gqlBaseProductQueryPartial}
      ${gqlProductPriceRangeQueryPartial}
      ${gqlConfigurableOptionsPartial}
      ${gqlConfigurableVariantsPartial}
      ... on PhysicalProductInterface {
        weight
      }
      shortdescription
      longdescription
      awardswidget_data
      brochuremode
      brochuremode2
      campaignvideowidget
      carevideowidget
      carewidget_data
      originalyear
      compareproductswidget_tasmb
      manufacturingfacility_data
      ancillarymanufacturingfacility_data
      breadcrumbs_data
      harness
      materials_c8_data
      miniwidget
      miniwidget_data
      keyfeatureswidget_data
      sizingfitwidget
      sizingchart_data
      technicalinfowidget_data
      alternateviews
      carevideowidget_data
      campaignwidget_data
      layeringwidget_tasmb_data
      compareproductswidget_tasmb_data
      customerservicetipswidget_data
      modelmetric_primary_data
      modelmetric_secondary_data
      isnew
      isrevised
      footwearweight
      packweightsml
      packweighttall
      packweightshort
      packweightregular
      packweightonesize
      packvolumetall
      packvolumeshort
      packvolumeonesize
      packvolumeregular
      packvolumeextendedonesize
      videosnippets
      conversionvideos
      hideprice
      othermaterialdescription
      miscellaneouswidget_data
    }

    ${gqlProductAggregations}

  }

}`;
const productPriceQueryTemplate = function (name, filter) {
  let pageSize = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 500;
  return gql`query ${name} {
  products(filter: ${filter}, pageSize: ${pageSize}) {
    items {
      name
      sku
      price_range {
        minimum_price{
            regular_price{
              value
              currency
            }
            discount {
              amount_off
              percent_off
            }
            final_price {
              value
              currency
            }
        }
        maximum_price{
          regular_price{
            value
            currency
          }
          discount {
            amount_off
            percent_off
          }
          final_price {
            value
            currency
          }
        }
      }
    }
  }
}`;
};
const productInventoryQueryTemplate = function (name, filter) {
  let pageSize = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 500;
  return gql`query ${name} {
  products(filter: ${filter}, pageSize: ${pageSize}) {
    items {
      name
      sku
      ...on ConfigurableProduct {
        variants {
          product {
            sku
            quantity_available
          }
        }
      }
    }
  }
}`;
};
const personalizedProductsTemplate = function (name, filter) {
  let pageSize = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 500;
  return gql`query ${name} {
  products(filter: ${filter}, pageSize: ${pageSize}) {
    items {
      name
      sku
      price_range {
        minimum_price{
          regular_price{
            value
            currency
          }
          discount {
            amount_off
            percent_off
          }
          final_price {
            value
            currency
          }
        }
        maximum_price{
          regular_price{
            value
            currency
          }
          discount {
            amount_off
            percent_off
          }
          final_price {
            value
            currency
          }
        }
      }
      ...on ConfigurableProduct {
        variants {
          product {
            sku
            quantity_available
          }
        }
      }
    }
  }
}`;
};
const productAggregationsTemplate = (name, filter) => gql`query ${name} {

  products(filter: ${filter}) {
    ${gqlProductAggregations}
  }

}`;
const gqlGetProductsBySku = productQueryTemplate("getProductsBySku($sku: String!)", "{ sku: { eq: $sku } }");
const gqlGetProductsBySlug = productQueryTemplate("getProductsBySlug($slug: String!)", "{ slug: { match: $slug } }");
const gqlGetProductsPricesBySku = productPriceQueryTemplate("gqlGetProductsPricesBySku($productSkus: [String!])", "{ sku: { in: $productSkus } }");
const gqlGetVariantsPricesBySku = variantPriceQueryTemplate("gqlGetVariantsPricesBySku($productSkus: [String!])", "{ sku: { in: $productSkus } }");
const gqlGetProductAggregationsBySku = productAggregationsTemplate("getProductsBySku($sku: String!)", "{ sku: { eq: $sku } }");
const gqlGetPersonalizedProductsBySkus = personalizedProductsTemplate("gqlGetPersonalizedProductsBySkus($productSkus: [String!])", "{ sku: { in: $productSkus } }");
const gqlGetProductInventoryBySkus = productInventoryQueryTemplate("gqlGetProductInventoryBySkus($productSkus: [String!])", "{ sku: { in: $productSkus } }");

const _excluded$2 = ["apiUrl", "country", "language", "market"];
class MagentoPersonalizedPriceProvider extends PersonalizedPriceProvider {
  constructor(_ref) {
    let {
        apiUrl,
        country,
        language,
        market
      } = _ref,
      providerOptions = _objectWithoutProperties(_ref, _excluded$2);
    super();
    this.apiUrl = apiUrl;
    this.priceList = {};
    this.variantsPriceList = {};
    this.MagentoGraphqlProvider = new MagentoGraphqlProvider(_objectSpread2({
      url: this.apiUrl,
      market,
      country,
      language
    }, providerOptions));
  }

  /**
   * @param productSkus An array of product skus
   */
  async fetchPrices() {
    let productSkus = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    const variables = {
      productSkus: [...productSkus]
    };
    try {
      if (!productSkus.length) {
        throw new Error("no product skus were providered.");
      }
      const magentoData = await this.MagentoGraphqlProvider.request(gqlGetProductsPricesBySku, variables).then(data => {
        /**
         * returns {
         *  [sku]: {
         *    product price payload
         *   }
         * }
         */
        return data.products.items.reduce((obj, item, index) => {
          var _item$price_range, _item$price_range2, _item$price_range3, _item$price_range4;
          return _objectSpread2(_objectSpread2({}, obj), {}, {
            [item.sku]: {
              price: Number(item === null || item === void 0 || (_item$price_range = item.price_range) === null || _item$price_range === void 0 || (_item$price_range = _item$price_range.maximum_price) === null || _item$price_range === void 0 || (_item$price_range = _item$price_range.regular_price) === null || _item$price_range === void 0 ? void 0 : _item$price_range.value),
              discountPrice: Number(item === null || item === void 0 || (_item$price_range2 = item.price_range) === null || _item$price_range2 === void 0 || (_item$price_range2 = _item$price_range2.maximum_price) === null || _item$price_range2 === void 0 || (_item$price_range2 = _item$price_range2.final_price) === null || _item$price_range2 === void 0 ? void 0 : _item$price_range2.value),
              minPrice: Number(item === null || item === void 0 || (_item$price_range3 = item.price_range) === null || _item$price_range3 === void 0 || (_item$price_range3 = _item$price_range3.minimum_price) === null || _item$price_range3 === void 0 || (_item$price_range3 = _item$price_range3.regular_price) === null || _item$price_range3 === void 0 ? void 0 : _item$price_range3.value),
              minDiscountPrice: Number(item === null || item === void 0 || (_item$price_range4 = item.price_range) === null || _item$price_range4 === void 0 || (_item$price_range4 = _item$price_range4.minimum_price) === null || _item$price_range4 === void 0 || (_item$price_range4 = _item$price_range4.final_price) === null || _item$price_range4 === void 0 ? void 0 : _item$price_range4.value)
            }
          });
        }, 0);
      });
      this.priceList = magentoData;
    } catch (error) {
      console.error(error);
    }
  }
  async fetchVariantsPrices() {
    let productSkus = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    const variables = {
      productSkus: [...productSkus]
    };
    try {
      if (!productSkus.length) {
        throw new Error("no product skus were providered.");
      }
      const magentoData = await this.MagentoGraphqlProvider.request(gqlGetVariantsPricesBySku, variables).then(data => {
        return data.products.items.reduce((acc, _ref2) => {
          let {
            variants
          } = _ref2;
          variants.forEach(_ref3 => {
            var _price_range$maximum_, _price_range$maximum_2;
            let {
              product
            } = _ref3;
            const {
              sku,
              price_range
            } = product;
            acc[sku] = {
              price: Number(price_range === null || price_range === void 0 || (_price_range$maximum_ = price_range.maximum_price) === null || _price_range$maximum_ === void 0 || (_price_range$maximum_ = _price_range$maximum_.regular_price) === null || _price_range$maximum_ === void 0 ? void 0 : _price_range$maximum_.value),
              discountPrice: Number(price_range === null || price_range === void 0 || (_price_range$maximum_2 = price_range.maximum_price) === null || _price_range$maximum_2 === void 0 || (_price_range$maximum_2 = _price_range$maximum_2.final_price) === null || _price_range$maximum_2 === void 0 ? void 0 : _price_range$maximum_2.value)
            };
          });
          return acc;
        }, {});
      });
      this.variantsPriceList = magentoData;
    } catch (error) {
      console.error(error);
    }
  }

  /**
   *
   * @param sku variant sku
   * @returns discount price of the variant
   */
  personalizedVariantPrice(sku) {
    var _this$variantsPriceLi;
    return (_this$variantsPriceLi = this.variantsPriceList[sku]) === null || _this$variantsPriceLi === void 0 ? void 0 : _this$variantsPriceLi.discountPrice;
  }

  /**
   * @param productId
   * @param price The regular base price
   * @param isPro Boolean that indicates if the given productId is a pro product (for legacy)
   */
  personalizePrice(productId, price, isPro) {
    var _this$priceList$produ;
    return ((_this$priceList$produ = this.priceList[productId]) === null || _this$priceList$produ === void 0 ? void 0 : _this$priceList$produ.discountPrice) || price;
  }
  getRealtimePrices(productId) {
    return this.priceList[productId];
  }
}

const _excluded$1 = ["apiUrl", "market", "country", "language"];
class MagentoInventoryProvider {
  constructor(_ref) {
    let {
        apiUrl: url,
        market,
        country,
        language
      } = _ref,
      providerOptions = _objectWithoutProperties(_ref, _excluded$1);
    this.inventory = {};
    this.magentoGraphqlProvider = new MagentoGraphqlProvider(_objectSpread2({
      url,
      market,
      country,
      language
    }, providerOptions));
  }
  async fetchInventory() {
    let productSkus = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    const variables = {
      productSkus: [...productSkus]
    };
    try {
      if (!productSkus.length) {
        throw new Error("no product skus were providered.");
      }
      const {
        products: {
          items
        }
      } = await this.magentoGraphqlProvider.request(gqlGetProductInventoryBySkus, variables);
      items.forEach(item => {
        const {
          sku,
          variants: itemVariants = []
        } = item;
        const variants = {};
        itemVariants.forEach(_ref2 => {
          let {
            product: {
              sku: variantId,
              quantity_available
            }
          } = _ref2;
          variants[variantId] = {
            quantity: Number(quantity_available)
          };
        });
        this.inventory[sku] = {
          variants
        };
      });
    } catch (error) {
      console.error(error);
    }
  }
  getVariantQuantity(productId, variantId) {
    var _this$inventory$produ;
    const variant = (_this$inventory$produ = this.inventory[productId]) === null || _this$inventory$produ === void 0 ? void 0 : _this$inventory$produ.variants[variantId];
    return variant ? variant.quantity : null;
  }
}

/* eslint-disable */
class MagentoPersonalizedProductProvider {
  constructor(_ref) {
    let {
      apiUrl: url,
      jwt,
      market,
      country,
      language
    } = _ref;
    if (!jwt) {
      throw new Error("No JWT provided. We cannot personalize if there's no JWT.");
    }
    this.personalizedProducts = {};
    this.MagentoGraphqlProvider = new MagentoGraphqlProvider({
      url,
      jwt,
      market,
      country,
      language
    });
  }
  async fetchPersonalProducts() {
    let productSkus = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    const variables = {
      productSkus: [...productSkus]
    };
    try {
      if (!productSkus.length) {
        throw new Error("no product skus were providered.");
      }
      const {
        products: {
          items
        }
      } = await this.MagentoGraphqlProvider.request(gqlGetPersonalizedProductsBySkus, variables);
      items.forEach(item => {
        var _price_range$maximum_;
        const {
          sku,
          price_range,
          variants: itemVariants = []
        } = item;
        const price = Number(price_range === null || price_range === void 0 || (_price_range$maximum_ = price_range.maximum_price) === null || _price_range$maximum_ === void 0 || (_price_range$maximum_ = _price_range$maximum_.final_price) === null || _price_range$maximum_ === void 0 ? void 0 : _price_range$maximum_.value);
        const variants = {};
        itemVariants.forEach(_ref2 => {
          let {
            product: {
              sku: variantId,
              quantity_available
            }
          } = _ref2;
          variants[variantId] = {
            quantity: Number(quantity_available)
          };
        });
        this.personalizedProducts[sku] = {
          price,
          variants
        };
      });
    } catch (error) {
      console.error(error);
    }
  }
  getPrice(productId) {
    var _this$personalizedPro;
    return ((_this$personalizedPro = this.personalizedProducts[productId]) === null || _this$personalizedPro === void 0 ? void 0 : _this$personalizedPro.price) || null;
  }
  getVariantQuantity(productId, variantId) {
    var _this$personalizedPro2;
    const variant = (_this$personalizedPro2 = this.personalizedProducts[productId]) === null || _this$personalizedPro2 === void 0 ? void 0 : _this$personalizedPro2.variants[variantId];
    return variant ? variant.quantity : null;
  }
}

class CartProvider {
  constructor(market, country, language) {
    this.market = market;
    this.country = country;
    this.language = language;
  }

  // Override this if you want to mutate the result of addToCart, getCart, etc
  processResult(result) {
    return result;
  }
}

const shippingOnCartPartialQuery = gql`
  shipping_addresses {
    firstname
    lastname
    street
    city
    postcode
    is_po_box
    region {
      code
      label
      region_id
    }
    country {
      code
      label
    }
    telephone
    pickup_location_code
    available_shipping_methods {
      amount {
        currency
        value
      }
      available
      carrier_code
      carrier_title
      error_message
      method_code
      method_title
      price_excl_tax {
        value
        currency
      }
      price_incl_tax {
        value
        currency
      }
    }
    selected_shipping_method {
      amount {
        value
        currency
      }
      carrier_code
      method_code
      carrier_title
      method_title
    }
  }
`;
const billingOnCartPartialQuery = gql`
  billing_address {
    firstname
    lastname
    company
    street
    city
    region{
      code
      label
      region_id
    }
    postcode
    telephone
    country{
      code
      label
    }
  }
`;
const cartMinimalTemplate = () => gql`
  cart {
    id
    email
  }
`;
const cartShippingMethodsTemplate = () => gql`
cart {
      email
      id
      shipping_addresses{
        selected_shipping_method{
          carrier_code
          carrier_title
          method_code
          method_title
          amount{
            value
            currency
          }
        }
      }
    }
`;
const cartTemplate = function () {
  let hasCartId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
  return gql`
cart${hasCartId ? "(cart_id: $cartId)" : ""} {
  email
  id
  total_quantity

  items {
    id
    quantity
    arc_sap_sourcing
    arc_original_country_price
    is_available
    prices {
      price {
        value
        currency
      }
      discounts {
        label
        amount {
          value
          currency
        }
      }
    }

    product {
      ${gqlBaseProductQueryPartial}
    }

    ... on ConfigurableCartItem {
      configured_variant {
        sku
        upc
        color_data
        size_data
        quantity_available
        productimage
      }
    }
  }

  applied_coupons {
    code
  }
  discount_notice
  ${shippingOnCartPartialQuery}
  ${billingOnCartPartialQuery}
  prices {
    grand_total {
      value
      currency
    }
    subtotal_excluding_tax {
      value
      currency
    }
    subtotal_including_tax {
      value
      currency
    }
    merged_taxes {
      amount{
          value
          currency
      }
      label
      percent
    }
    discounts {
      label
      amount {
        value
        currency
      }
    }
  }
  selected_payment_method {
    code
    title
  }
}`;
};
const createEmptyCartMutation = gql`
  mutation createEmptyCart {
    createEmptyCart
  }
`;
const getCartQuery = gql`
  query getCart($cartId: String!) {
    ${cartTemplate(true)}
  }
`;
const addConfigurableProductsToCartMutation = gql`
  mutation addConfigurableProductsToCart($cartId: String!, $preSku: String!, $preParentSku: String!, $quantity: Float!) {
    addConfigurableProductsToCart(
      input: { cart_id: $cartId, cart_items: [{ parent_sku: $preParentSku, data: { quantity: $quantity, sku: $preSku } }] }
    ) {
      ${cartTemplate()}
    }
  }
`;
const addMultipleConfigurableProductsToCartMutation = gql`
  mutation addConfigurableProductsToCart(
  $cartId: String!,
  $cartItems: [ConfigurableProductCartItemInput]!
  ) {
    addConfigurableProductsToCart(
      input: { cart_id: $cartId, cart_items: $cartItems }
    ) {
      ${cartTemplate()}
    }
  }
`;
const removeItemFromCartMutation = gql`
  mutation removeItemFromCartMutation($cartId: String!, $cartItemId: Int!) {
    removeItemFromCart(input: { cart_id: $cartId, cart_item_id: $cartItemId }) {
      ${cartTemplate()}
    }
  }
`;
const updateSingleCartItemMutation = gql`
  mutation updateCartItemsMutation($cartId: String!, $cartItemId: Int!, $quantity: Float!) {
    updateCartItems(input: { cart_id: $cartId, cart_items: [{ cart_item_id: $cartItemId, quantity: $quantity }] }) {
      ${cartTemplate()}
    }
  }
`;
const updateMultipleCartItemsMutation = gql`
  mutation updateCartItemsMutation($cartId: String!, $cartItems: [CartItemUpdateInput!]!) {
    updateCartItems(input: { cart_id: $cartId, cart_items: $cartItems }) {
      ${cartTemplate()}
    }
  }
`;
const applyCouponToCartMutation = gql`
  mutation applyCouponToCartMutation($cartId: String!, $code: String!) {
    applyCouponToCart(input: { cart_id: $cartId, coupon_code: $code }) {
      ${cartTemplate()}
    }
  }
`;
const removeCouponFromCartMutation = gql`
  mutation removeCouponFromCartMutation($cartId: String!) {
    removeCouponFromCart(input: { cart_id: $cartId }) {
      ${cartTemplate()}
    }
  }
`;
const setGuestEmailMutation = () => gql`
  mutation setGuestEmailOnCart($cartId: String!, $email: String!, $arcNewsletterOptins: Boolean!) {
    setGuestEmailOnCart(input: { cart_id: $cartId, email: $email, arc_newsletter_optins: $arcNewsletterOptins }) {
      ${cartTemplate()}
    }
  }
`;
const setShippingAddressMutation = _ref => {
  let {
    isPickUp = false,
    useMinimalCartResponse
  } = _ref;
  return gql`
  mutation setShippingAddressMutation(
    $cartId: String!,
    $firstName: String!,
    $lastName: String!,
    $street: [String]!,
    $city: String!,
    $region: String!,
    $regionId: Int,
    $postcode: String!,
    $country: String!,
    $phone: String!,
    $isPoBox: Boolean!,
    ${isPickUp ? "$pickUpCode: String!," : ""}
  ) {
    setShippingAddressesOnCart(
      input: {
        cart_id: $cartId
        shipping_addresses: {
          address: {
            firstname: $firstName
            lastname: $lastName
            street: $street
            city: $city
            region: $region
            region_id: $regionId
            postcode: $postcode
            country_code: $country
            telephone: $phone
            is_po_box: $isPoBox
            save_in_address_book: false
          },
          ${isPickUp ? "pickup_location_code: $pickUpCode" : ""}
        }
      }
    ) {
      ${useMinimalCartResponse ? cartMinimalTemplate() : cartTemplate()}
    }
  }
`;
};
const getAdyenPaymentMethodsQuery = country => gql`
  query getAdyenPaymentMethods(${country ? "$cartId: String!, $country: String" : "$cartId: String!"}) {
    adyenPaymentMethods(${country ? "cart_id: $cartId, country: $country" : "cart_id: $cartId"}) {
      
      paymentMethodsExtraDetails {
        type
        icon {
          url
          width
          height
        }
        isOpenInvoice
        configuration {
          amount {
            value
            currency
          }
          currency
        }
      }
      paymentMethodsResponse {
        paymentMethods {
          name
          type
          brand
          brands
          configuration {
            merchantId
            merchantName
          }
        }
      }
    }
  }
`;
const setBillingAddressMutation = useMinimalCartResponse => gql`
  mutation setBillingAddressMutation(
    $cartId: String!
    $firstName: String!
    $lastName: String!
    $street: [String]!
    $city: String!
    $region: String
    $regionId: Int
    $postCode: String
    $countryCode: String!
    $telephone: String
    $arcSaveAddress: Boolean!
  ) {
    setBillingAddressOnCart(
      input: {
        cart_id: $cartId
        arc_save_address: $arcSaveAddress
        billing_address: {
          address: {
            firstname: $firstName
            lastname: $lastName
            street: $street
            city: $city
            region: $region
            region_id: $regionId
            postcode: $postCode
            country_code: $countryCode
            telephone: $telephone
            save_in_address_book: false
          }
          same_as_shipping: false
        }
      }
    ) {
      ${useMinimalCartResponse ? cartMinimalTemplate() : cartTemplate()}
    }
  }
`;
const setShippingMethodMutation = useMinimalCartResponse => gql`
  mutation setShippingMethodMutation($cartId: String!, $code: String!, $methodCode: String!) {
    setShippingMethodsOnCart(
      input: { cart_id: $cartId, shipping_methods: [{ carrier_code: $code, method_code: $methodCode }] }
    ) {
      ${useMinimalCartResponse ? cartShippingMethodsTemplate() : cartTemplate()}
    }
  }
`;
const setPaymentMethodMutation = useMinimalCartResponse => gql`
  mutation setPaymentMethodMutation($cartId: String!, $paymentMethod: String!) {
    setPaymentMethodOnCart(input: { cart_id: $cartId, payment_method: { code: $paymentMethod } }) {
      ${useMinimalCartResponse ? `cart {
              selected_payment_method {
                code
                title
              }
            }` : cartTemplate()}
    }
  }
`;
const getAdyenPaymentStatus = gql`
  query getAdyenPaymentStatus($orderNumber: String!, $cartId: String!) {
    adyenPaymentStatus(orderNumber: $orderNumber, cartId: $cartId) {
      isFinal
      resultCode
      additionalData
      action
    }
  }
`;
const getAdyenPaymentDetails = gql`
  mutation getAdyenPaymentDetails($payload: String!, $cartId: String!) {
    adyenPaymentDetails(payload: $payload, cart_id: $cartId) {
      isFinal
      resultCode
      additionalData
      action
    }
  }
`;
const setAdyenPaymentInfoAndPlaceOrderMutation = gql`
  mutation setPaymentMethodAndPlaceOrder(
    $cartId: String!
    $paymentMethod: PaymentMethodInput!
    $additionalData: String
  ) {
    setPaymentMethodOnCart(input: { cart_id: $cartId, payment_method: $paymentMethod }) {
      cart {
        selected_payment_method {
          code
          title
        }
      }
    }
    placeOrder(input: { cart_id: $cartId, additional_data: $additionalData }) {
      order {
        order_number
        cart_id
        adyen_payment_status {
          isFinal
          resultCode
          additionalData
          action
        }
      }
    }
  }
`;
const getPaymentStatusQuery = gql`
  query getPaymentStatusQuery($orderId: Int!) {
    paymentStatus(order_id: $orderId) {
      success
      threeDS2
      token
      type
      redirect_method
      redirect_url
    }
  }
`;
const processThreeDSSecureMutation = gql`
  mutation processThreeDSSecureMutation($payload: ThreeDS2ProcessInput) {
    threeDS2Process(input: $payload) {
      threeDS2
      type
      token
      action
      result
    }
  }
`;
const gqlValidateShippingAddress = gql`
  mutation ($cartId: String!, $address: CartAddressInput!) {
    arcAddressValidation(input: { cart_id: $cartId, shipping_addresses: { address: $address } }) {
      arc_address_validation_attributes {
        arc_address_validation_state
        arc_address_validation_classification
        arc_address_validation_effective_address {
          firstname
          lastname
          company
          street
          city
          postcode
          telephone
          country {
            code
            label
          }
          region {
            code
            label
          }
        }
        arc_address_validation_pobox
      }
    }
  }
`;
const recreateCartMutation = gql`
  mutation recreateCartMutation($cartId: String!) {
    arcCartReactivation(input: { cart_id: $cartId }) {
      cart_id
    }
  }
`;
const getAdyenPaymentMethodsBalance = gql`
  query adyenPaymentMethodsBalance($payload: String!) {
    adyenPaymentMethodsBalance(payload: $payload) {
      balanceResponse
    }
  }
`;
const saveGiftCardStateData = gql`
  mutation adyenSaveStateData($stateData: String!, $cartId: String!) {
    adyenSaveStateData(stateData: $stateData, cartId: $cartId) {
      stateDataId
    }
  }
`;
const removeGiftCardStateData = gql`
  mutation adyenRemoveStateData($stateDataId: Int!, $cartId: String!) {
    adyenRemoveStateData(stateDataId: $stateDataId, cartId: $cartId) {
      stateDataId
    }
  }
`;
const getAdyenRedeemedGiftcards = gql`
  query adyenRedeemedGiftcards($cartId: String!) {
    adyenRedeemedGiftcards(cartId: $cartId) {
      redeemedGiftcards {
        stateDataId
        brand
        title
        balance {
          currency
          value
        }
        deductedAmount
      }
      remainingAmount
      totalDiscount
    }
  }
`;

const findItemsWithWrongQuantity = cart => {
  // find all the products that have wrong quantity
  const needUpdate = [];
  cart.items.forEach(item => {
    const quantity_available = item === null || item === void 0 ? void 0 : item.configured_variant.quantity_available;
    if ((item === null || item === void 0 ? void 0 : item.quantity) > quantity_available && quantity_available !== 0) {
      needUpdate.push({
        cart_item_id: item.id,
        quantity: quantity_available
      });
    }
  });
  return needUpdate;
};
const appendCustomErrorMessage = (updatedCart, needUpdate) => {
  needUpdate.forEach(updateItem => {
    var _updatedCart$items;
    const item = updatedCart === null || updatedCart === void 0 || (_updatedCart$items = updatedCart.items) === null || _updatedCart$items === void 0 ? void 0 : _updatedCart$items.find(cartItem => {
      if (cartItem !== null) {
        return cartItem.id === updateItem.cart_item_id;
      }
    });
    item.customError = "WRONG-QUANTITY";
  });
};
const handleWrongQuantityUpdate = async (cart, cartId, provider) => {
  const cartItems = findItemsWithWrongQuantity(cart);
  let response = {};
  try {
    const {
      updateCartItems: {
        cart: updatedCartSuccess
      }
    } = await provider.request(updateMultipleCartItemsMutation, {
      cartId,
      cartItems
    });
    response = {
      cart: updatedCartSuccess
    };
  } catch (error) {
    if (error instanceof MagentoGraphqlProviderError) {
      const {
        response: {
          errors,
          data: {
            updateCartItems: {
              cart: updatedCartError
            }
          }
        }
      } = error;
      response = {
        cart: updatedCartError,
        errors
      };
    }
  }
  appendCustomErrorMessage(response.cart, cartItems);
  return response;
};
const replaceModelNumberWithSku = (errors, sku) => {
  errors.forEach(error => {
    if (error.message.match(/Could not add the product with SKU [a-zA-Z0-9]+ to the shopping cart: The requested qty is not available/)) {
      error.message = `Could not add the product with SKU ${sku} to the shopping cart: The requested qty is not available`;
    }
  });
};

const _excluded = ["url", "market", "country", "language", "cartId", "onNewCartCreated", "kioskId", "useMinimalCartResponse", "isReserved", "headers", "onIsCheckoutRequestSuccess", "onNotIsCheckoutRequestSuccess", "onError"];
const cookies = new Cookies();
const STORE_ID_COOKIE_NAME = "ARC-KIOSK-STORE-ID";
const getKioskId = () => cookies.get(STORE_ID_COOKIE_NAME) || null;
class MagentoCartProvider extends CartProvider {
  constructor(_ref) {
    let {
        url,
        market,
        country,
        language,
        cartId = "",
        onNewCartCreated = () => null,
        kioskId,
        useMinimalCartResponse = false,
        isReserved = false,
        headers = {},
        /** Function to run after sending a request with X-IS-CHECKOUT=true */
        onIsCheckoutRequestSuccess = undefined,
        /** Function to run after sending a request with X-IS-CHECKOUT=false */
        onNotIsCheckoutRequestSuccess = undefined,
        /** Function to send messages to log (e.g. New Relic)  */
        onError = undefined
      } = _ref,
      providerParams = _objectWithoutProperties(_ref, _excluded);
    super(market, country, language);
    this.checkout = false;
    this.provider = null;
    this.cartCountKey = market === "sale" || market === "outlet" ? "CartCount-SALE" : "CartCount-OUTDOOR";
    this.cartId = cartId || null;
    this.currentCart = null;
    this.url = url;
    this.onNewCartCreated = onNewCartCreated;
    this.kioskId = kioskId || getKioskId();
    this.useMinimalCartResponse = useMinimalCartResponse;
    this.isReserved = isReserved;
    this.headers = headers;
    this.onIsCheckoutRequestSuccess = onIsCheckoutRequestSuccess;
    this.onNotIsCheckoutRequestSuccess = onNotIsCheckoutRequestSuccess;
    this.onError = onError;

    // pass along any extra props to the graphql provider
    this.providerParams = providerParams;

    // Initialize the graphql provider after everything else has been set
    this.resetProvider();
  }

  /* Override processResult from CartProvider
   *  - set selected product variant/color/size => TODO: should be removed once configured_variant gets available
   *  - update currentCart to the latest working cart
   *  - update Cart Count on every processResult
   */
  processResult(_ref2) {
    let {
      cart,
      errors
    } = _ref2;
    this.currentCart = cart;
    return super.processResult({
      cart,
      errors
    });
  }
  resetProvider() {
    this.provider = new MagentoGraphqlProvider(_objectSpread2(_objectSpread2({}, this.providerParams), {}, {
      url: this.url,
      market: this.market,
      country: this.country,
      language: this.language,
      isCheckout: this.checkout,
      kioskId: this.kioskId,
      headers: this.headers,
      onIsCheckoutRequestSuccess: this.onIsCheckoutRequestSuccess,
      onNotIsCheckoutRequestSuccess: this.onNotIsCheckoutRequestSuccess,
      onError: this.onError
    }));
  }

  /* Change the x-is-checkout header for differentiating between checkout and cart pages */
  setIsCheckout() {
    let isCheckout = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
    this.checkout = isCheckout;
    this.resetProvider();
  }
  setIsKiosk(kioskId) {
    this.kioskId = kioskId;
    this.resetProvider();
  }
  async _initCart() {
    if (!this.cartId) {
      await this._createEmptyCart();
    }
  }
  async _createEmptyCart() {
    try {
      const {
        createEmptyCart: cartId
      } = await this.provider.request(createEmptyCartMutation);
      this.cartId = cartId;
      this.onNewCartCreated(cartId);
    } catch (error) {
      console.error(error);
    }
  }
  async getCart() {
    let overridingSchema = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
    try {
      await this._initCart();
      const {
        cart
      } = await this.provider.request(overridingSchema || getCartQuery, {
        cartId: this.cartId
      });
      return this.processResult({
        cart
      });
    } catch (error) {
      if (error instanceof MagentoGraphqlProviderError) {
        const {
          response: {
            errors,
            data: {
              cart
            }
          }
        } = error;
        if (error.hasError(/Could not find a cart with ID "\w+"/) || error.hasError(/The cart isn't active./)) {
          this.cartId = null;
          return await this.getCart();
        }
        if (error.hasError("The requested qty is not available")) {
          const response = await handleWrongQuantityUpdate(cart, this.cartId, this.provider);
          return this.processResult(response);
        }
        return this.processResult({
          cart,
          errors
        });
      }

      // Magent not available. Let container-cart handle it and show active cart with general alert
      console.error(error);
      throw new Error(error);
    }
  }
  async addToCart(_ref3) {
    let {
      id,
      sku,
      quantity = 1,
      overridingSchema = null
    } = _ref3;
    try {
      await this._initCart();
      const {
        addConfigurableProductsToCart: {
          cart
        }
      } = await this.provider.request(overridingSchema || addConfigurableProductsToCartMutation, {
        cartId: this.cartId,
        preParentSku: id,
        preSku: sku,
        quantity
      });
      return this.processResult({
        cart
      });
    } catch (error) {
      if (error instanceof MagentoGraphqlProviderError) {
        const {
          response: {
            errors,
            data: {
              addConfigurableProductsToCart
            }
          }
        } = error;
        if (error.hasError(/Could not find a cart with ID "\w+"/) || error.hasError(/The cart isn't active./)) {
          this.cartId = null;
          return await this.addToCart({
            id,
            sku,
            quantity
          });
        }
        if (error.hasError(/Could not add the product with SKU [a-zA-Z0-9]+ to the shopping cart: The requested qty is not available/)) {
          const {
            cart
          } = await this.provider.request(getCartQuery, {
            cartId: this.cartId
          });
          // replace the returned model level sku with the variant level sku. See data-models::Adapters/Magento/Product.js
          // to see how this gets turned into a WRONG-QUANTITY error.
          replaceModelNumberWithSku(errors, sku);
          return this.processResult({
            cart,
            errors
          });
        }
        return this.processResult({
          cart: addConfigurableProductsToCart === null || addConfigurableProductsToCart === void 0 ? void 0 : addConfigurableProductsToCart.cart,
          errors
        });
      }

      // reset the cart before throwing an error
      await this._createEmptyCart();
      await this.getCart();
      throw new Error(error);
    }
  }
  async removeFromCart(_ref4) {
    let {
      cartItemId,
      overridingSchema = null
    } = _ref4;
    try {
      const {
        removeItemFromCart: {
          cart
        }
      } = await this.provider.request(overridingSchema || removeItemFromCartMutation, {
        cartId: this.cartId,
        cartItemId
      });
      return this.processResult({
        cart
      });
    } catch (error) {
      if (error instanceof MagentoGraphqlProviderError) {
        const {
          response: {
            errors,
            data: {
              removeItemFromCart
            }
          }
        } = error;
        return this.processResult({
          cart: removeItemFromCart === null || removeItemFromCart === void 0 ? void 0 : removeItemFromCart.cart,
          errors
        });
      }

      // Magent not available. Let container-cart handle it and show active cart with general alert
      console.error(error);
      throw new Error(error);
    }
  }
  async changeQuantity(_ref5) {
    let {
      cartItemId,
      quantity,
      overridingSchema = null
    } = _ref5;
    try {
      const {
        updateCartItems: {
          cart
        }
      } = await this.provider.request(overridingSchema || updateSingleCartItemMutation, {
        cartId: this.cartId,
        cartItemId,
        quantity
      });
      return this.processResult({
        cart
      });
    } catch (error) {
      if (error instanceof MagentoGraphqlProviderError) {
        const {
          response: {
            errors,
            data: {
              updateCartItems
            }
          }
        } = error;
        if (error.hasError(/Could not update the product with SKU [a-zA-Z0-9]+: The requested qty is not available/)) {
          return this.processResult({
            cart: this.currentCart,
            errors
          });
        }
        return this.processResult({
          cart: updateCartItems === null || updateCartItems === void 0 ? void 0 : updateCartItems.cart,
          errors
        });
      }

      // Magent not available. Let container-cart handle it and show active cart with general alert
      console.error(error);
      throw new Error(error);
    }
  }
  async addPromoCode(code) {
    let overridingSchema = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    try {
      const {
        applyCouponToCart: {
          cart
        }
      } = await this.provider.request(overridingSchema || applyCouponToCartMutation, {
        cartId: this.cartId,
        code
      });
      return this.processResult({
        cart
      });
    } catch (error) {
      if (error instanceof MagentoGraphqlProviderError) {
        const {
          response: {
            errors,
            data: {
              applyCouponToCart
            }
          }
        } = error;
        if (error.hasError("Some of the products are out of stock.") || error.hasError("Some of the products are no longer available.")) {
          return this.processResult({
            cart: applyCouponToCart === null || applyCouponToCart === void 0 ? void 0 : applyCouponToCart.cart,
            errors
          });
        }
        return this.processResult({
          cart: this.currentCart,
          errors
        });
      }

      // Magent not available. Let container-cart handle it and show active cart with general alert
      console.error(error);
      throw new Error(error);
    }
  }
  async removePromoCode() {
    let overridingSchema = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
    try {
      const {
        removeCouponFromCart: {
          cart
        }
      } = await this.provider.request(overridingSchema || removeCouponFromCartMutation, {
        cartId: this.cartId
      });
      return this.processResult({
        cart
      });
    } catch (error) {
      if (error instanceof MagentoGraphqlProviderError) {
        const {
          response: {
            errors,
            data: {
              removeCouponFromCart
            }
          }
        } = error;
        if (error.hasError("Some of the products are out of stock.") || error.hasError("Some of the products are no longer available.")) {
          return this.processResult({
            cart: removeCouponFromCart === null || removeCouponFromCart === void 0 ? void 0 : removeCouponFromCart.cart,
            errors
          });
        }
        return this.processResult({
          cart: this.currentCart,
          errors
        });
      }

      // Magent not available. Let container-cart handle it and show active cart with general alert
      console.error(error);
      throw new Error(error);
    }
  }
  async removeOutOfStockProductsFromCart(adaptedCart) {
    let overridingSchema = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    const cartItems = adaptedCart.products.filter(product => product.isOutOfStock).map(product => ({
      cart_item_id: product.cartItemId,
      quantity: 0
    }));
    if (cartItems.length > 0) {
      try {
        const {
          updateCartItems: {
            cart
          }
        } = await this.provider.request(overridingSchema || updateMultipleCartItemsMutation, {
          cartId: adaptedCart.id,
          cartItems
        });
        return this.processResult({
          cart
        });
      } catch (error) {
        return error;
      }
    }
  }
  async setShippingMethod(_ref6) {
    let {
      code,
      methodCode,
      overridingSchema = null
    } = _ref6;
    try {
      const {
        setShippingMethodsOnCart: {
          cart
        }
      } = await this.provider.request(overridingSchema || setShippingMethodMutation(this.useMinimalCartResponse), {
        cartId: this.cartId,
        code,
        methodCode
      });
      return this.processResult({
        cart
      });
    } catch (error) {
      if (error instanceof MagentoGraphqlProviderError) {
        const {
          response: {
            errors,
            data: {
              setShippingMethodsOnCart
            }
          }
        } = error;
        if (error.hasError(/Carrier with such method not found/)) {
          return this.processResult({
            cart: this.currentCart,
            errors
          });
        }
        return this.processResult({
          cart: setShippingMethodsOnCart === null || setShippingMethodsOnCart === void 0 ? void 0 : setShippingMethodsOnCart.cart,
          errors
        });
      }

      // Network error, return previously working cart
      console.error(error);
      return this.processResult({
        cart: this.currentCart,
        errors: [{
          message: "network error"
        }]
      });
    }
  }

  /**
   * @return {PaymentMethodsArray} check MagentoCartProvider.mock.js getPaymentMethodsResponse
   */
  async getPaymentMethods(country) {
    let overridingSchema = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    const adyenMethodQuery = getAdyenPaymentMethodsQuery(country);
    try {
      var _paymentMethodsRespon;
      const paymentMethodsResponse = await this.provider.request(overridingSchema || adyenMethodQuery, {
        cartId: this.cartId,
        country
      });
      return paymentMethodsResponse === null || paymentMethodsResponse === void 0 || (_paymentMethodsRespon = paymentMethodsResponse.adyenPaymentMethods) === null || _paymentMethodsRespon === void 0 ? void 0 : _paymentMethodsRespon.paymentMethodsResponse.paymentMethods;
    } catch (error) {
      console.error(error);
      return {
        error
      };
    }
  }

  /**
   * @param {String} paymentMethod <required > ie 'adyen_cc'
   * @return {CartObject}
   */
  async setPaymentMethod(paymentMethod) {
    let overridingSchema = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    try {
      const {
        setPaymentMethodOnCart: {
          cart
        }
      } = await this.provider.request(overridingSchema || setPaymentMethodMutation(this.useMinimalCartResponse), {
        cartId: this.cartId,
        paymentMethod
      });
      return this.processResult({
        cart
      });
    } catch (error) {
      if (error instanceof MagentoGraphqlProviderError) {
        const {
          response: {
            errors,
            data: {
              setPaymentMethodOnCart
            }
          }
        } = error;
        if (error.hasError(/The requested Payment Method is not available/)) {
          return this.processResult({
            cart: this.currentCart,
            errors
          });
        }
        return this.processResult({
          cart: setPaymentMethodOnCart === null || setPaymentMethodOnCart === void 0 ? void 0 : setPaymentMethodOnCart.cart,
          errors
        });
      }

      // Magent not available return previously working cart
      console.error(error);
      return this.processResult({
        cart: this.currentCart
      });
    }
  }

  /**
   * @param {paymentPayloadObject} paymentPayload <required > {payment_method: {method, additional_data}}
   * @param {String} email <required >
   * @param {String} additionalData <required > for shoe products only "{\"product_attributes\":{\"sku\":{\"key1\":\"value1\",\"key2\":\"value2\"}}}"
   * @return {String} order id
   */
  async setPaymentInfoAndPlaceOrder(_ref7) {
    let {
      paymentPayload,
      additionalData = null,
      overridingSchema = null
    } = _ref7;
    const paymentInfoQuery = setAdyenPaymentInfoAndPlaceOrderMutation;
    const gqlVars = {
      cartId: this.cartId,
      paymentMethod: paymentPayload,
      additionalData
    };
    try {
      const {
        setPaymentMethodOnCart,
        placeOrder
      } = await this.provider.request(overridingSchema || paymentInfoQuery, gqlVars);
      const {
        cart
      } = setPaymentMethodOnCart;
      const {
        order
      } = placeOrder;
      return {
        cart,
        order
      };
    } catch (error) {
      console.error(error);
      return {
        error
      };
    }
  }

  /**
   * @param {String} orderId <required> the order id returned from setPaymentInfoAndPlaceOrder
   * @param {String} cartId <required> the cart id from Magento
   * @return {adyenPaymentStatus} isFinal: boolean, resultCode: string, additionalData, action
   */
  async getAdyenPaymentStatus(_ref8) {
    let {
      orderId,
      cartId,
      overridingSchema = null
    } = _ref8;
    try {
      const {
        adyenPaymentStatus
      } = await this.provider.request(overridingSchema || getAdyenPaymentStatus, {
        orderNumber: orderId,
        cartId
      });
      return adyenPaymentStatus;
    } catch (error) {
      console.error(error);
      return {
        error
      };
    }
  }

  /**
   * @param {String} payload <required> the order id returned from setPaymentInfoAndPlaceOrder
   * @param {String} cartId <required> the cart id from Magento
   * @return {adyenPaymentDetails} isFinal: boolean, resultCode: string, additionalData, action
   */
  async getAdyenPaymentDetails(_ref9) {
    let {
      payload,
      cartId,
      overridingSchema = null
    } = _ref9;
    try {
      const {
        adyenPaymentDetails
      } = await this.provider.request(overridingSchema || getAdyenPaymentDetails, {
        payload,
        cartId
      });
      return adyenPaymentDetails;
    } catch (error) {
      console.error(error);
      return {
        error
      };
    }
  }

  /**
   * @param {String} payload <required> the payload returned from onCheckBalanceEvent
   * @return {adyenPaymentMethodsBalance} {{balanceResponse: {pspReference: string, resultCode: string, balance}}}
   */
  async getAdyenPaymentMethodsBalance(_ref10) {
    let {
      payload,
      overridingSchema = null
    } = _ref10;
    try {
      const {
        adyenPaymentMethodsBalance
      } = await this.provider.request(overridingSchema || getAdyenPaymentMethodsBalance, {
        payload
      });
      return adyenPaymentMethodsBalance;
    } catch (error) {
      console.error(error);
      return {
        error
      };
    }
  }

  /**
   * @param {String} stateData <required> the payload returned from onCheckBalanceEvent
   * @param {String} cartId <required> the cart id from Magento
   * @return {adyenSaveStateData} stateDataId:string
   */
  async saveGiftCardStateData(_ref11) {
    let {
      stateData,
      cartId,
      overridingSchema = null
    } = _ref11;
    try {
      const {
        adyenSaveStateData
      } = await this.provider.request(overridingSchema || saveGiftCardStateData, {
        stateData,
        cartId
      });
      return adyenSaveStateData;
    } catch (error) {
      console.error(error);
      return {
        error
      };
    }
  }

  /**
   * @param {String} stateDataId <required> the payload returned from onCheckBalanceEvent
   * @param {String} cartId <required> the cart id from Magento
   * @return {adyenRemoveStateData} stateDataId:string
   */
  async removeGiftCardStateData(_ref12) {
    let {
      stateDataId,
      cartId,
      overridingSchema = null
    } = _ref12;
    try {
      const {
        adyenRemoveStateData
      } = await this.provider.request(overridingSchema || removeGiftCardStateData, {
        stateDataId,
        cartId
      });
      return adyenRemoveStateData;
    } catch (error) {
      console.error(error);
      return {
        error
      };
    }
  }

  /**
   * @param {String} cartId <required> the cart id from Magento
   * @return {adyenRedeemedGiftcards} {{redeemedGiftcards: {  stateDataId:string, brand:string,  title:string,  balance {  currency:string,  value:number  },  deductedAmount:string  },  remainingAmount:string,  totalDiscount:string}}
   */
  async getAdyenRedeemedGiftcards(_ref13) {
    let {
      cartId,
      overridingSchema = null
    } = _ref13;
    try {
      const {
        adyenRedeemedGiftcards
      } = await this.provider.request(overridingSchema || getAdyenRedeemedGiftcards, {
        cartId
      });
      return adyenRedeemedGiftcards;
    } catch (error) {
      console.error(error);
      return {
        error
      };
    }
  }

  /**
   * @param {Integer} orderId <required > the order id returned from setPaymentInfoAndPlaceOrder
   * @return {PaymentStatusObject} redirect_method, redirect_url, success: boolean, threeDS2: boolean, token: string, type: string
   */
  async getPaymentStatus(orderId) {
    let overridingSchema = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    try {
      const {
        paymentStatus
      } = await this.provider.request(overridingSchema || getPaymentStatusQuery, {
        orderId
      });
      return paymentStatus;
    } catch (error) {
      console.error(error);
      return {
        error
      };
    }
  }
  async processThreeDSSecure(payload) {
    let overridingSchema = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    try {
      const {
        threeDS2Process
      } = await this.provider.request(overridingSchema || processThreeDSSecureMutation, {
        payload
      });
      return threeDS2Process;
    } catch (error) {
      console.error(error);
      return {
        error
      };
    }
  }
  async fetchSuggestedShippingAddresses(_ref14) {
    let {
      firstName,
      lastName,
      address1,
      address2,
      city,
      province,
      country,
      postalCode,
      phone,
      isPoBox,
      overridingSchema = null
    } = _ref14;
    const address = {
      firstname: firstName,
      lastname: lastName,
      company: null,
      street: [address1],
      city,
      region: province,
      country_code: country,
      postcode: postalCode,
      telephone: phone,
      is_po_box: Boolean(isPoBox)
    };
    if (address2) {
      address.street.push(address2);
    }
    try {
      const {
        arcAddressValidation: {
          arc_address_validation_attributes: {
            arc_address_validation_effective_address: addresses = []
          } = {}
        } = {}
      } = await this.provider.request(overridingSchema || gqlValidateShippingAddress, {
        cartId: this.cartId,
        address
      });
      return addresses;
    } catch (error) {
      console.error(error);
      return []; // fail gracefully but output the problem to console
    }
  }

  /**
   * guestInfo: {
   *   email: string,
   *   emailConsent: boolean,
   * }
   */
  async setGuestEmailAddress(guestInfo) {
    let overridingSchema = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    const setGuestEmailAddressMutation = setGuestEmailMutation();
    const {
      email,
      emailConsent
    } = guestInfo;
    try {
      const {
        setGuestEmailOnCart: {
          cart
        }
      } = await this.provider.request(overridingSchema || setGuestEmailAddressMutation, {
        cartId: this.cartId,
        email,
        arcNewsletterOptins: Boolean(emailConsent)
      });
      if (cart.email) {
        // caching
        this.processResult({
          cart
        });
      } else {
        throw new Error("email is not registered in cart");
      }
      return true;
    } catch (error) {
      console.error(error);
      return {
        error
      };
    }
  }
  async setShippingAddress(address) {
    let includeRegionIds = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    let overridingSchema = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
    const {
      address1,
      address2,
      firstName,
      lastName,
      city,
      region,
      province,
      postalCode,
      country,
      phone,
      isPoBox,
      regionId
    } = address || {};
    const streetArr = [address1];
    if (address2) {
      streetArr.push(address2);
    }
    const shippingQuery = overridingSchema || setShippingAddressMutation({
      useMinimalCartResponse: this.useMinimalCartResponse
    });
    try {
      const {
        setShippingAddressesOnCart: {
          cart
        }
      } = await this.provider.request(shippingQuery, {
        cartId: this.cartId,
        firstName,
        lastName,
        street: streetArr,
        city,
        region: province || region || "",
        // prioritize province for backward compatibility
        regionId: includeRegionIds ? parseInt(regionId, 10) : null,
        country,
        postcode: postalCode,
        isPoBox: Boolean(isPoBox),
        phone
      });
      if (cart.shipping_addresses || cart.id) {
        // turn this flag on because this is when reservation is made
        this.isReserved = true;
        // caching
        this.processResult({
          cart
        });
      }
      return Boolean(cart.shipping_addresses || cart.id);
    } catch (error) {
      console.error(error);
      return {
        error
      };
    }
  }
  async setShippingAddressPickUp(pickUpInfo) {
    let overridingSchema = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    try {
      const {
        firstName,
        lastName,
        street,
        city,
        region,
        country,
        postcode,
        pickUpPhone: phone,
        pickUpCode
      } = pickUpInfo;
      const {
        setShippingAddressesOnCart: {
          cart
        }
      } = await this.provider.request(overridingSchema || setShippingAddressMutation({
        isPickUp: true,
        useMinimalCartResponse: this.useMinimalCartResponse
      }), {
        cartId: this.cartId,
        firstName,
        lastName,
        street: street ? [street] : ["813 Burrard Street"],
        city: city ? city : "Vancouver",
        region: region ? region : "BC",
        country: country ? country : "CA",
        postcode: postcode ? postcode : "V6Z 1X8",
        isPoBox: false,
        phone,
        pickUpCode
      });
      return this.processResult({
        cart
      });
    } catch (error) {
      console.error(error);
      return {
        error
      };
    }
  }
  async setBillingAddress(_ref15) {
    let {
      address,
      cartId,
      arcSaveAddress,
      telephone = "",
      phone = "",
      includeRegionIds = false,
      overridingSchema = null
    } = _ref15;
    try {
      const {
        address1,
        address2,
        firstName,
        lastName,
        city,
        region,
        regionId,
        province,
        postalCode,
        country
      } = address || {};
      const street = [address1];
      if (address2) {
        street.push(address2);
      }
      const {
        setBillingAddressOnCart: {
          cart
        }
      } = await this.provider.request(overridingSchema || setBillingAddressMutation(this.useMinimalCartResponse), {
        cartId,
        arcSaveAddress,
        firstName,
        lastName,
        street,
        city,
        region: province || region || "",
        // prioritize province for backward compatibility
        regionId: includeRegionIds ? parseInt(regionId, 10) : null,
        countryCode: country,
        postCode: postalCode,
        telephone: telephone || phone // set same phone number as on shipping address
      });
      this.processResult({
        cart
      });
      return Boolean(cart.billing_address || cart.id);
    } catch (error) {
      console.error(error);
      return {
        error
      };
    }
  }
  async recreateCart(cartId) {
    let overridingSchema = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    const {
      arcCartReactivation: {
        cart_id
      }
    } = await this.provider.request(overridingSchema || recreateCartMutation, {
      cartId
    });
    this.onNewCartCreated(cart_id);
    return cart_id;
  }
}

class CartShareProvider extends CartProvider {
  constructor(_ref) {
    let {
      market,
      country,
      language,
      reCaptchaSiteKey = "",
      emailMyCartUrl = ""
    } = _ref;
    super(market, country, language);
    this.reCaptchaSiteKey = reCaptchaSiteKey;
    this.emailMyCartUrl = emailMyCartUrl;
  }
  getReCaptchaSiteKey() {
    return this.reCaptchaSiteKey;
  }
  emailSubmit(cartData) {
    return fetch(this.emailMyCartUrl, {
      method: "POST",
      headers: {
        "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8"
      },
      body: JSON.stringify(cartData)
    }).then(response => {
      if (!response.ok) {
        throw new Error(`${response.statusText} when fetching ${this.emailMyCartUrl}`);
      }
      return response.json();
    }).then(_ref2 => {
      let {
        statusCode
      } = _ref2;
      const okCode = 200;
      return statusCode === okCode;
    });
    // .catch(error => {
    //   console.error("Fetch Error", error);
    // });
  }
  collateCartData(email, cart, reCaptchaValue, user) {
    // Grab all the data we need for email-my-cart on form submit
    const isSpecialUser = (user === null || user === void 0 ? void 0 : user.isPro) || (user === null || user === void 0 ? void 0 : user.isIndustry) || (user === null || user === void 0 ? void 0 : user.groupPrefix) === "PR" || (user === null || user === void 0 ? void 0 : user.groupPrefix) === "IN";
    const isSale = this.market === "sale";
    const cartObj = {};
    cartObj.captcha = reCaptchaValue;
    cartObj.email = email;
    cartObj.products = cart.products.map(p => {
      var _p$selectedColour, _p$selectedSize, _p$selectedColour2;
      // if outdoor, use simple line price
      let price = priceFormat(p === null || p === void 0 ? void 0 : p.linePrice, p === null || p === void 0 ? void 0 : p.currencyCode, this.country, this.language);

      // if special user and outdoor, use this html string
      if (isSpecialUser && !isSale) {
        price = `\n<span class="proPricing">
              <span class="product-price__value" data-currency="${cart.currencyCode}" data-language="EN" data-country="CA" content="${p.linePrice}" data-price="${p.linePrice}">${priceFormat(p === null || p === void 0 ? void 0 : p.linePrice, p === null || p === void 0 ? void 0 : p.currencyCode, this.country, this.language)}</span>
            </span>\n
            <span class="newPrice">
              <span class="product-price__value" data-currency="${cart.currencyCode}" data-language="EN" data-country="CA" content="${p.lineDiscountPrice}" data-price="${p.lineDiscountPrice}">${priceFormat(p === null || p === void 0 ? void 0 : p.lineDiscountPrice, p === null || p === void 0 ? void 0 : p.currencyCode, this.country, this.language)}</span>
            </span>\n\n`;
      }
      if (isSale) {
        price = priceFormat(p === null || p === void 0 ? void 0 : p.lineDiscountPrice, p === null || p === void 0 ? void 0 : p.currencyCode, this.country, this.language);
      }
      return {
        model: `${p === null || p === void 0 ? void 0 : p.id}`,
        link: `${window.location.protocol}//${window.location.hostname}${p.url}`,
        name: p === null || p === void 0 ? void 0 : p.name,
        sizeAndColour: `${p === null || p === void 0 || (_p$selectedColour = p.selectedColour) === null || _p$selectedColour === void 0 ? void 0 : _p$selectedColour.label} ${p === null || p === void 0 || (_p$selectedSize = p.selectedSize) === null || _p$selectedSize === void 0 ? void 0 : _p$selectedSize.label}`,
        price,
        qty: `${p === null || p === void 0 ? void 0 : p.quantity}`,
        img: (_p$selectedColour2 = p.selectedColour) === null || _p$selectedColour2 === void 0 || (_p$selectedColour2 = _p$selectedColour2.image) === null || _p$selectedColour2 === void 0 ? void 0 : _p$selectedColour2.url
      };
    });
    return cartObj;
  }
  async emailMyCart(_ref3) {
    let {
      email,
      cart,
      reCaptchaValue,
      user
    } = _ref3;
    const cartData = this.collateCartData(email, cart, reCaptchaValue, user);
    return await this.emailSubmit(cartData);
  }
}

/**
 *   @param  {string}  env - The environment to use (dev, stage, prod)
 */
class AmerOrderHistoryProvider {
  constructor(env) {
    this.baseUrl = env === "dev" || env === "stage" ? `https://api.arcteryx-routes.com/order-history-${env}` : "https://api.arcteryx-routes.com/order-history";
  }
  _fetch(url, headers) {
    return fetch$1(url, {
      headers
    }).then(response => {
      if (response.status !== 200) {
        return null;
      }
      return response.json();
    });
  }

  /**
   *   Fetches order history for an authenticated user. This returns an array of of Orders.
   *   @param  {string}  jwt - The JWT token for an authenticated user
   *   @param  {number}  monthFilter - The number of month to filter orders by. Valid values are 6 or 12.
   *   @param  {string}  yearFilter - The current year valid from January 1st. Valid value is current_year.
   */
  async getMultipleOrders(jwt, monthFilter, yearFilter) {
    let url = `${this.baseUrl}`;
    if (monthFilter === 6 || monthFilter === 12) {
      url += `?monthFilter=${monthFilter}`;
    }
    if (yearFilter) {
      url += `?yearFilter='${yearFilter}'`;
    }
    const headers = {
      "x-jwt": jwt
    };
    return await this._fetch(url, headers);
  }

  /**
   *   Fetches order history for a single order.
   *   @param  {string}  email - The email address associated to the order
   *   @param  {string}  orderNumber - The orderNumber of the order
   */
  async getSingleOrder(email, orderNumber) {
    return await this._fetch(`${this.baseUrl}?email=${email}&orderNumber=${orderNumber}`);
  }
}

const gqlGetAllCountriesAndRegions = gql`
  query {
    countries {
      id
      two_letter_abbreviation
      full_name_english
      full_name_locale
      available_regions {
        id
        code
        name
      }
    }
  }
`;

class CartIdService {
  constructor(localStorageKey) {
    this.localStorageKey = localStorageKey;
  }
  _cartIdMapKey() {
    return `${this.localStorageKey}-CartIdMap`;
  }
  _readCartIdMap() {
    try {
      return JSON.parse(localStorage.getItem(this._cartIdMapKey()));
    } catch (e) {
      console.error(e);
      return {};
    }
  }
  _setCartIdMap(map) {
    localStorage.setItem(this._cartIdMapKey(), JSON.stringify(map));
  }
  getCartForUser(userId) {
    var _this$_readCartIdMap;
    return (_this$_readCartIdMap = this._readCartIdMap()) === null || _this$_readCartIdMap === void 0 ? void 0 : _this$_readCartIdMap[userId];
  }
  setCartId(_ref) {
    let {
      userId,
      cartId
    } = _ref;
    this._setCartIdMap(_objectSpread2(_objectSpread2({}, this._readCartIdMap()), {}, {
      [userId]: cartId
    }));
  }

  /**
   * There is a requirement that if a user is not logged in, and adds item to a cart that the next user who logs in
   * takes that cart, So we'll store latestMutatedCart_${key}, for
   */
  _latestMutatedCartKey() {
    return `latestMutatedCart-${this.localStorageKey}`;
  }
  setLatestMutatedAnonymousCart(cartId) {
    localStorage.setItem(this._latestMutatedCartKey(), cartId || "");
  }
  getLatestMutatedAnonymousCart() {
    return localStorage.getItem(this._latestMutatedCartKey());
  }

  /**
   * Takes the cart from latest mutated cart
   */
  giveLatestMutatedCartToUser(userId) {
    this.setCartId({
      userId,
      cartId: this.getLatestMutatedAnonymousCart()
    });
    this.setLatestMutatedAnonymousCart();
  }
}

class FormstackProvider {
  constructor(_ref) {
    let {
      authToken
    } = _ref;
    this.headers = {
      Accept: "application/json",
      "Content-Type": "application/json",
      Authorization: `Bearer ${authToken}`
    };
  }
  async fetchForm(formId) {
    const {
      headers
    } = this;
    return (await fetch(`https://www.formstack.com/api/v2/form/${formId}.json`, {
      headers
    })).json();
  }
  async submitForm(formId, data) {
    const {
      headers
    } = this;
    return (await fetch(`https://www.formstack.com/api/v2/form/${formId}/submission.json`, {
      method: "POST",
      headers,
      body: JSON.stringify(data)
    })).json();
  }
}

export { AmerOrderHistoryProvider, BazaarVoiceProvider, BloomreachProvider, CartIdService, CartShareProvider, FormstackProvider, MagentoCartProvider, MagentoGraphqlProvider, MagentoInventoryProvider, MagentoPersonalizedPriceProvider, MagentoPersonalizedProductProvider, MagentoStoreListProvider, addConfigurableProductsToCartMutation, addMultipleConfigurableProductsToCartMutation, applyCouponToCartMutation, billingOnCartPartialQuery, capitalize, cartMinimalTemplate, cartShippingMethodsTemplate, cartTemplate, createEmptyCartMutation, flattenCMSJson, generateRandomNumber, getAdyenPaymentDetails, getAdyenPaymentMethodsBalance, getAdyenPaymentMethodsQuery, getAdyenPaymentStatus, getAdyenRedeemedGiftcards, getCartQuery, getJWT, getPaymentStatusQuery, gqlBaseProductQueryPartial, gqlConfigurableOptionsPartial, gqlConfigurableVariantsPartial, gqlGetAllCountriesAndRegions, gqlGetPersonalizedProductsBySkus, gqlGetProductAggregationsBySku, gqlGetProductInventoryBySkus, gqlGetProductInventoryByStores, gqlGetProductsBySku, gqlGetProductsBySlug, gqlGetProductsPricesBySku, gqlGetStores, gqlGetVariantsPricesBySku, gqlProductAggregations, gqlProductPriceRangeQueryPartial, gqlValidateShippingAddress, processThreeDSSecureMutation, recreateCartMutation, removeCouponFromCartMutation, removeGiftCardStateData, removeItemFromCartMutation, saveGiftCardStateData, setAdyenPaymentInfoAndPlaceOrderMutation, setBillingAddressMutation, setGuestEmailMutation, setPaymentMethodMutation, setShippingAddressMutation, setShippingMethodMutation, shippingOnCartPartialQuery, updateMultipleCartItemsMutation, updateSingleCartItemMutation, warehouses };
//# sourceMappingURL=index.js.map
